<template>
  <div class="header">
    <div class="top_head">
      <span class="goBack" @click="$router.go(-1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M20,11H7.83l5.59-5.59L12,4,4,12l8,8,1.41-1.41L7.83,13H20Z" />
        </svg>
      </span>
    </div>
    <div class="business-profile">
      <div class="profile-img">
        <img :src="userProfileImage" v-if="userProfileImage" />
        <img src="../../assets/images/user_images.png" />
      </div>
      <h3>{{userProfile.user}}</h3>

      <div class="profile-location">
        <img src="../../assets/images/icon_map_grey.svg" />
        {{location}}
      </div>
      <div class="profile-stats">
        <ul>
          <li>
            {{userProfile.total_feeds}}
            <span>{{$t('TotalPost')}}</span>
          </li>
          <li>
            {{userProfile.total_likes}}
            <span>{{$t('TotalLikes')}}</span>
          </li>
          <li>
            {{userProfile.total_comments}}
            <span>{{$t('TotalComments')}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueCookie from "vue-cookie";
Vue.use(VueCookie);
export default {
  name: "ProfileHeader",
  data() {
    return {
      location: VueCookie.get("cityName"),
      userProfileImage:null
    };
  },
  props: {
    userProfile: Object,
    require: true
  },
  computed: {},
  methods: {},
     mounted() {
    let headers = {
      "x-auth-id": this.$cookie.get("X-Auth-Id")
    };
    this.$http
      .get("https://be.payboard.in/PayBoard/rest/user/balance", { headers })
      .then(function(data) {
        this.location = VueCookie.get('cityName')||data.body.data.city.name;
        this.userProfileImage = data.body.data.profileImageUrl;
      });
  }
};
</script>

<style></style>
